import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { isProductInStock } from '~/utils/ProductAvailability';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { ProductKeys } from '~/types/ProductEnums';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzAttributeChoiceSelect',
  props: {
    variants: null
  },
  emits: ['on-variant-changed'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var selectedAttribute = ref('');
    var options = computed(function () {
      var attributes = new Set();
      var _iterator = _createForOfIteratorHelper(props.variants),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var variant = _step.value;
          if (variant.isDiscontinued) continue;
          attributes.add(variant.attributes[ProductKeys.capacity].label);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return attributes;
    });

    /**
     * Sets the selected attribute.
     *
     * @param      {string}  attribute  The attribute
     */
    function setSelectedAttribute(attribute) {
      selectedAttribute.value = attribute;
      changeVariant();
    }

    /**
     * Sets the attribute type.
     *
     * @param      {(ProductKeys.capacity|ProductKeys.color)}  type    The type
     */
    function getVariant(attribute) {
      return props.variants.find(function (variant) {
        return variant.attributes[ProductKeys.capacity].label === attribute;
      });
    }

    /**
     * Gets the price from the given attribute.
     *
     * @param      {string}          attribute  The attribute
     * @return     {PriceUnitModel}  The price.
     */
    function getPrice(attribute) {
      var _variant$price, _variant$price$discou, _variant$price$discou2;
      var variant = getVariant(attribute);
      return {
        regular: variant.price.value.centAmount / 100,
        special: ((_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : (_variant$price$discou = _variant$price.discounted) === null || _variant$price$discou === void 0 ? void 0 : (_variant$price$discou2 = _variant$price$discou.value) === null || _variant$price$discou2 === void 0 ? void 0 : _variant$price$discou2.centAmount) / 100
      };
    }

    /**
     * Sends an event to change the selected variant
     *
     * @emits      #event:on-variant-changed
     */
    function changeVariant() {
      emit('on-variant-changed', _defineProperty({}, ProductKeys.capacity, {
        label: selectedAttribute.value
      }));
    }
    watch(options, function (newValue, oldValue) {
      // Sets are weird man!
      selectedAttribute.value = newValue.keys().next().value;
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      selectedAttribute: selectedAttribute,
      options: options,
      setSelectedAttribute: setSelectedAttribute,
      getVariant: getVariant,
      getPrice: getPrice,
      changeVariant: changeVariant,
      AzIcon: AzIcon,
      isProductInStock: isProductInStock,
      PriceDisplay: PriceDisplay
    };
  }
});